import { SET_THEME } from '../actions/types';

function getInitialMode() {
  try {
    const saved = localStorage.getItem('app-theme');
    if (saved === 'dark' || saved === 'light') return saved;
  } catch (e) {}
  return 'light';
}

const initialState = {
  mode: getInitialMode(),
};

export default function theme(state = initialState, action) {
  if (action.type === SET_THEME) {
    const next = { ...state, mode: action.payload };
    console.log("[theme reducer] SET_THEME | payload:", action.payload, "| next mode:", next.mode);
    return next;
  }
  return state;
}
